<template>
  <div class="flex flex-col">
    <template v-if="partner">
      <h4>{{ t('selectPartner') }}</h4>
      <div class="flex flex-1 flex-col justify-center">
        <div
          class="flex w-fit items-center justify-between gap-2 rounded-md bg-green-100 px-3 py-1 text-sm text-green-800"
        >
          <BuildingIcon class="h-4 w-4" />
          <span>{{ partner.company }}</span>
          <Button
            variant="ghost"
            size="sm"
            class="h-auto !bg-transparent p-0 text-green-600 hover:text-green-800"
            @click="removePartnerCode"
          >
            <XIcon class="h-3 w-3" />
          </Button>
        </div>
      </div>
    </template>
    <SearchUserInput
      v-else
      :allowed-roles="[UserRole.COMPANY, UserRole.AGENCY]"
      :label="t('selectPartner')"
      :selected-user="partner"
      @update-user="handleUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import SearchUserInput from '@/components/booking-forms/customer/SearchUserInput.vue';
import type { User } from '@/entities/auth/user.entity';
import { UserRole } from '@carvia/ros-client-types';

import { BuildingIcon, XIcon } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  partner?: User;
}>();

const emit = defineEmits<{
  (event: 'change', partner?: User): void;
}>();

const { t } = useI18n();

const handleUpdate = (newPartner?: User) => {
  emit('change', newPartner);
};

const removePartnerCode = () => {
  emit('change', undefined);
};
</script>

<i18n lang="json">
{
  "en": {
    "selectPartner": "Agency / Business Customer"
  },
  "de": {
    "selectPartner": "Vermittler-/Businesskunde"
  },
  "es": {
    "selectPartner": "Agencia / cliente empresa"
  }
}
</i18n>
